import { getQueryStringValue } from "../../../../services/utils/getQueryStringValue"

export const buildParams = (search, sort) => {
  const {
    colors,
    sizes,
    type,
    orientations,
    medium,
    material,
    minHeight,
    maxHeight,
    minWidth,
    maxWidth,
  } = search

  const queryStringValue = getQueryStringValue("search")

  let params = {}
  if (sizes.length > 0) {
    params["size"] = sizes
  }
  if (type?.length > 0) {
    params["type"] = type
  }
  if (orientations.length > 0) {
    params["orientation"] = orientations
  }
  if (medium.length > 0) {
    params["medium"] = medium
  }
  if (material.length > 0) {
    params["material"] = material
  }
  if (colors.length > 0) {
    params["colorsfilter"] = colors
  }
  if (minHeight && minHeight > 0) {
    params["minh"] = minHeight
  }
  if (maxHeight && maxHeight > 0) {
    params["maxh"] = maxHeight
  }
  if (minWidth && minWidth > 0) {
    params["minw"] = minWidth
  }
  if (maxWidth && maxWidth > 0) {
    params["maxw"] = maxWidth
  }
  if (sort) {
    params["order"] = sort
  }
  if (!!queryStringValue) {
    params["search"] = queryStringValue
  }

  return params
}
